import type { PhaseKey } from "@akina/domain";
import { create } from "zustand";
import { type TherapyPlanConfig, type TherapyPlanManagementData, type TPMStrategy } from "../therapyPlanManagementTypes";

type TherapyPlanManagementViewState = {
  data: TherapyPlanManagementData | null;
  initialData: TherapyPlanManagementData | null;
  config: TherapyPlanConfig | null;
  strategy: TPMStrategy | null;
  favouriteExercises: Set<string>;
  isLoading: boolean;
  phaseKey?: PhaseKey;

  actions: {
    init: (data: TherapyPlanManagementData, config: TherapyPlanConfig, strategy: TPMStrategy) => void;
    cleanup: () => void;
    setIsLoading: (isLoading: boolean) => void;
    setPhaseKey: (key?: PhaseKey) => void;
    setData: (data: TherapyPlanManagementData | null) => void;
    setFavouriteExercises: (exerciseKeys: string[]) => void;
  };
};

export const useTherapyPlanManagementViewStore = create<TherapyPlanManagementViewState>(set => ({
  data: null,
  initialData: null,
  config: null,
  strategy: null,
  favouriteExercises: new Set(),
  isLoading: true,
  phaseKey: undefined,

  actions: {
    init: (data, config, strategy) =>
      set({
        data: structuredClone(data),
        initialData: structuredClone(data),
        config,
        strategy,
        isLoading: false,
      }),

    cleanup: () =>
      set({
        data: null,
        initialData: null,
        config: null,
        strategy: null,
        favouriteExercises: new Set(),
        isLoading: true,
        phaseKey: undefined,
      }),

    setIsLoading: isLoading => set({ isLoading }),
    setPhaseKey: phaseKey => set({ phaseKey }),
    setData: data => set({ data: data ?? null }),
    setFavouriteExercises: exerciseKeys => set({ favouriteExercises: new Set(exerciseKeys) }),
  },
}));
